// Dados mock completos para todos os módulos
import type { Cliente, Fornecedor, Produto, Servico, Empresa, Transportadora, NotaFiscal, DashboardStats } from '../types';

// Empresa emitente
export const empresaMock: Empresa = {
  id: '1',
  razaoSocial: 'Sistema de Notas Fiscais LTDA',
  nomeFantasia: 'NF Sistema',
  cnpj: '12.345.678/0001-90',
  inscricaoEstadual: '123456789',
  email: 'contato@nfsistema.com.br',
  telefone: '(11) 98765-4321',
  endereco: {
    cep: '01310-100',
    logradouro: 'Avenida Paulista',
    numero: '1000',
    complemento: 'Sala 100',
    bairro: 'Bela Vista',
    cidade: 'São Paulo',
    estado: 'SP',
  },
};

// Clientes
export const clientesMock: Cliente[] = [
  {
    id: '1',
    nome: 'João Silva',
    tipo: 'F',
    cpf: '123.456.789-00',
    email: 'joao.silva@email.com',
    telefone: '(11) 98765-4321',
    endereco: {
      cep: '01310-100',
      logradouro: 'Rua das Flores',
      numero: '123',
      complemento: 'Apto 45',
      bairro: 'Centro',
      cidade: 'São Paulo',
      estado: 'SP',
    },
    createdAt: '2024-01-15T10:00:00',
    updatedAt: '2024-01-15T10:00:00',
  },
  {
    id: '2',
    nome: 'Maria Santos',
    tipo: 'F',
    cpf: '987.654.321-00',
    email: 'maria.santos@email.com',
    telefone: '(21) 98765-4321',
    endereco: {
      cep: '20040-020',
      logradouro: 'Avenida Atlântica',
      numero: '456',
      bairro: 'Copacabana',
      cidade: 'Rio de Janeiro',
      estado: 'RJ',
    },
    createdAt: '2024-01-16T11:00:00',
    updatedAt: '2024-01-16T11:00:00',
  },
  {
    id: '3',
    nome: 'Tech Solutions LTDA',
    tipo: 'J',
    cnpj: '98.765.432/0001-10',
    email: 'contato@techsolutions.com.br',
    telefone: '(11) 3456-7890',
    endereco: {
      cep: '04547-130',
      logradouro: 'Rua Funchal',
      numero: '789',
      complemento: '10º andar',
      bairro: 'Vila Olímpia',
      cidade: 'São Paulo',
      estado: 'SP',
    },
    createdAt: '2024-01-17T09:00:00',
    updatedAt: '2024-01-17T09:00:00',
  },
  {
    id: '4',
    nome: 'Carlos Oliveira',
    tipo: 'F',
    cpf: '111.222.333-44',
    email: 'carlos.oliveira@email.com',
    telefone: '(31) 98765-4321',
    endereco: {
      cep: '30130-010',
      logradouro: 'Avenida Afonso Pena',
      numero: '1000',
      bairro: 'Centro',
      cidade: 'Belo Horizonte',
      estado: 'MG',
    },
    createdAt: '2024-01-18T14:00:00',
    updatedAt: '2024-01-18T14:00:00',
  },
  {
    id: '5',
    nome: 'Empresa ABC Comércio',
    tipo: 'J',
    cnpj: '11.222.333/0001-44',
    email: 'vendas@empresaabc.com.br',
    telefone: '(47) 3456-7890',
    endereco: {
      cep: '89010-000',
      logradouro: 'Rua XV de Novembro',
      numero: '500',
      bairro: 'Centro',
      cidade: 'Blumenau',
      estado: 'SC',
    },
    createdAt: '2024-01-19T10:00:00',
    updatedAt: '2024-01-19T10:00:00',
  },
  {
    id: '6',
    nome: 'Ana Paula Costa',
    tipo: 'F',
    cpf: '555.666.777-88',
    email: 'ana.costa@email.com',
    telefone: '(85) 98765-4321',
    endereco: {
      cep: '60160-000',
      logradouro: 'Avenida Beira Mar',
      numero: '200',
      bairro: 'Meireles',
      cidade: 'Fortaleza',
      estado: 'CE',
    },
    createdAt: '2024-01-20T08:00:00',
    updatedAt: '2024-01-20T08:00:00',
  },
];

// Fornecedores
export const fornecedoresMock: Fornecedor[] = [
  {
    id: '1',
    nome: 'Distribuidora XYZ',
    cnpj: '88.777.666/0001-55',
    email: 'vendas@distribuidoraxyz.com.br',
    telefone: '(11) 3456-7890',
    endereco: {
      cep: '01310-100',
      logradouro: 'Rua dos Fornecedores',
      numero: '1000',
      bairro: 'Bela Vista',
      cidade: 'São Paulo',
      estado: 'SP',
    },
    createdAt: '2024-01-10T10:00:00',
    updatedAt: '2024-01-10T10:00:00',
  },
  {
    id: '2',
    nome: 'Indústria ABC',
    cnpj: '77.666.555/0001-44',
    email: 'contato@industriaabc.com.br',
    telefone: '(21) 3456-7890',
    endereco: {
      cep: '20040-020',
      logradouro: 'Rua Industrial',
      numero: '500',
      bairro: 'Centro',
      cidade: 'Rio de Janeiro',
      estado: 'RJ',
    },
    createdAt: '2024-01-11T11:00:00',
    updatedAt: '2024-01-11T11:00:00',
  },
];

// Produtos
export const produtosMock: Produto[] = [
  {
    id: '1',
    codigo: 'PROD001',
    descricao: 'Notebook Dell Inspiron 15',
    categoria: 'Informática',
    precoVenda: 2999.90,
    precoCompra: 2200.00,
    unidadeMedida: 'UN',
    ncm: '8471.30.12',
    cest: '010.0600',
    estoque: 25,
    createdAt: '2024-01-10T10:00:00',
    updatedAt: '2024-01-10T10:00:00',
  },
  {
    id: '2',
    codigo: 'PROD002',
    descricao: 'Mouse Logitech MX Master 3',
    categoria: 'Informática',
    precoVenda: 599.90,
    precoCompra: 400.00,
    unidadeMedida: 'UN',
    ncm: '8471.60.90',
    estoque: 50,
    createdAt: '2024-01-10T11:00:00',
    updatedAt: '2024-01-10T11:00:00',
  },
  {
    id: '3',
    codigo: 'PROD003',
    descricao: 'Teclado Mecânico RGB',
    categoria: 'Informática',
    precoVenda: 799.90,
    precoCompra: 550.00,
    unidadeMedida: 'UN',
    ncm: '8471.60.90',
    estoque: 30,
    createdAt: '2024-01-10T12:00:00',
    updatedAt: '2024-01-10T12:00:00',
  },
  {
    id: '4',
    codigo: 'PROD004',
    descricao: 'Monitor LG 27" 4K',
    categoria: 'Informática',
    precoVenda: 1999.90,
    precoCompra: 1500.00,
    unidadeMedida: 'UN',
    ncm: '8528.72.10',
    estoque: 15,
    createdAt: '2024-01-11T10:00:00',
    updatedAt: '2024-01-11T10:00:00',
  },
  {
    id: '5',
    codigo: 'PROD005',
    descricao: 'Cadeira Gamer Ergonômica',
    categoria: 'Móveis',
    precoVenda: 1299.90,
    precoCompra: 900.00,
    unidadeMedida: 'UN',
    ncm: '9401.30.00',
    estoque: 20,
    createdAt: '2024-01-11T11:00:00',
    updatedAt: '2024-01-11T11:00:00',
  },
];

// Serviços
export const servicosMock: Servico[] = [
  {
    id: '1',
    codigo: 'SERV001',
    descricao: 'Desenvolvimento de Software',
    unidadeMedida: 'H',
    valor: 150.00,
    codigoMunicipal: '1.03.01',
    createdAt: '2024-01-10T10:00:00',
    updatedAt: '2024-01-10T10:00:00',
  },
  {
    id: '2',
    codigo: 'SERV002',
    descricao: 'Consultoria em TI',
    unidadeMedida: 'H',
    valor: 200.00,
    codigoMunicipal: '1.03.01',
    createdAt: '2024-01-10T11:00:00',
    updatedAt: '2024-01-10T11:00:00',
  },
  {
    id: '3',
    codigo: 'SERV003',
    descricao: 'Manutenção de Equipamentos',
    unidadeMedida: 'UN',
    valor: 350.00,
    codigoMunicipal: '1.03.02',
    createdAt: '2024-01-10T12:00:00',
    updatedAt: '2024-01-10T12:00:00',
  },
  {
    id: '4',
    codigo: 'SERV004',
    descricao: 'Suporte Técnico',
    unidadeMedida: 'H',
    valor: 120.00,
    codigoMunicipal: '1.03.01',
    createdAt: '2024-01-11T10:00:00',
    updatedAt: '2024-01-11T10:00:00',
  },
];

// Transportadoras
export const transportadorasMock: Transportadora[] = [
  {
    id: '1',
    nome: 'Transportadora Express',
    cnpj: '99.888.777/0001-66',
    email: 'contato@transportadoraexpress.com.br',
    telefone: '(11) 3456-7890',
    endereco: {
      cep: '01310-100',
      logradouro: 'Rua dos Transportadores',
      numero: '500',
      bairro: 'Bela Vista',
      cidade: 'São Paulo',
      estado: 'SP',
    },
    createdAt: '2024-01-10T10:00:00',
    updatedAt: '2024-01-10T10:00:00',
  },
  {
    id: '2',
    nome: 'Logística Rápida',
    cnpj: '66.555.444/0001-33',
    email: 'contato@logisticarapida.com.br',
    telefone: '(21) 3456-7890',
    endereco: {
      cep: '20040-020',
      logradouro: 'Avenida Logística',
      numero: '300',
      bairro: 'Centro',
      cidade: 'Rio de Janeiro',
      estado: 'RJ',
    },
    createdAt: '2024-01-11T11:00:00',
    updatedAt: '2024-01-11T11:00:00',
  },
];

// Notas Fiscais
export const notasFiscaisMock: NotaFiscal[] = [
  {
    id: '1',
    tipo: 'NFe',
    numero: '000001',
    serie: '001',
    chaveAcesso: '35200112345678000190550000000000123456789012',
    emitente: empresaMock,
    destinatario: clientesMock[0],
    dataEmissao: '2024-01-20T10:00:00',
    dataVencimento: '2024-02-20T10:00:00',
    itens: [
      {
        id: '1',
        tipo: 'produto',
        produtoId: '1',
        descricao: 'Notebook Dell Inspiron 15',
        quantidade: 2,
        unidadeMedida: 'UN',
        valorUnitario: 2999.90,
        valorTotal: 5999.80,
        ncm: '8471.30.12',
      },
    ],
    subtotal: 5999.80,
    desconto: 0,
    total: 5999.80,
    status: 'emitida',
    formaPagamento: 'Boleto',
  },
  {
    id: '2',
    tipo: 'NFSe',
    numero: '000001',
    serie: '001',
    emitente: empresaMock,
    destinatario: clientesMock[1],
    dataEmissao: '2024-01-21T14:00:00',
    itens: [
      {
        id: '1',
        tipo: 'servico',
        servicoId: '1',
        descricao: 'Desenvolvimento de Software',
        quantidade: 40,
        unidadeMedida: 'H',
        valorUnitario: 150.00,
        valorTotal: 6000.00,
      },
    ],
    subtotal: 6000.00,
    desconto: 0,
    total: 6000.00,
    status: 'emitida',
  },
  {
    id: '3',
    tipo: 'NFCe',
    numero: '000001',
    serie: '001',
    emitente: empresaMock,
    destinatario: clientesMock[2],
    dataEmissao: '2024-01-22T16:00:00',
    itens: [
      {
        id: '1',
        tipo: 'produto',
        produtoId: '2',
        descricao: 'Mouse Logitech MX Master 3',
        quantidade: 1,
        unidadeMedida: 'UN',
        valorUnitario: 599.90,
        valorTotal: 599.90,
      },
    ],
    subtotal: 599.90,
    desconto: 0,
    total: 599.90,
    status: 'emitida',
    formaPagamento: 'Cartão de Crédito',
  },
];

// Estatísticas do Dashboard
export const dashboardStatsMock: DashboardStats = {
  notasEmitidas: 150,
  notasPendentes: 5,
  totalMes: 125000.00,
  totalAno: 1250000.00,
  notasPorTipo: {
    NFe: 80,
    NFSe: 50,
    NFCe: 20,
  },
};
